    (() => {
      if (window.__lymaCollectionSwipeLoaded) return;
      window.__lymaCollectionSwipeLoaded = true;

      const states = new WeakMap();

      const getState = (gallery) => {
        if (!states.has(gallery)) {
          states.set(gallery, {
            index: 0,
            startX: 0,
            startY: 0,
            dx: 0,
            horizontal: false,
            dragging: false,
            suppressClick: false
          });
        }
        return states.get(gallery);
      };

      const slideCount = (gallery) =>
        gallery.querySelectorAll('[data-lyma-slide]').length;

      const render = (gallery, animate = true, dragOffset = 0) => {
        const st = getState(gallery);
        const track = gallery.querySelector('[data-lyma-track]');
        if (!track) return;

        const width = gallery.getBoundingClientRect().width || gallery.clientWidth || 1;
        track.style.transition = animate ? 'transform .28s ease' : 'none';
        track.style.transform =
          `translate3d(${(-st.index * width) + dragOffset}px, 0, 0)`;

        gallery.querySelectorAll('[data-lyma-dot]').forEach((dot, i) => {
          dot.classList.toggle('is-active', i === st.index);
        });
      };

      const startDrag = (gallery, x, y) => {
        const st = getState(gallery);
        st.startX = x;
        st.startY = y;
        st.dx = 0;
        st.horizontal = false;
        st.dragging = true;
        st.suppressClick = false;
        gallery.classList.add('is-dragging');
      };

      const moveDrag = (gallery, x, y, event) => {
        const st = getState(gallery);
        if (!st.dragging) return;

        const dx = x - st.startX;
        const dy = y - st.startY;

        if (!st.horizontal) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;

          /* Zodra de beweging duidelijk horizontaal is, nemen wij hem over.
             Is hij verticaal, dan laten we de pagina gewoon scrollen. */
          if (Math.abs(dy) > Math.abs(dx)) {
            st.dragging = false;
            gallery.classList.remove('is-dragging');
            return;
          }

          st.horizontal = true;
        }

        st.dx = dx;
        st.suppressClick = Math.abs(dx) > 8;

        if (event && event.cancelable) event.preventDefault();
        render(gallery, false, dx);
      };

      const endDrag = (gallery) => {
        const st = getState(gallery);
        if (!st.dragging && !st.horizontal) return;

        const count = slideCount(gallery);
        const width = gallery.getBoundingClientRect().width || gallery.clientWidth || 1;
        const threshold = Math.min(50, width * 0.18);

        if (st.horizontal && Math.abs(st.dx) > threshold) {
          if (st.dx < 0) st.index = Math.min(count - 1, st.index + 1);
          if (st.dx > 0) st.index = Math.max(0, st.index - 1);
        }

        st.dragging = false;
        st.horizontal = false;
        st.dx = 0;
        gallery.classList.remove('is-dragging');
        render(gallery, true, 0);
      };

      /* iPhone / Android: explicit touch events for the COLLECTION card.
         These are delegated, so filtering/sorting that replaces product cards
         does not break swipe. */
      document.addEventListener('touchstart', (event) => {
        const gallery = event.target.closest?.('[data-lyma-gallery]');
        if (!gallery || event.touches.length !== 1) return;

        const touch = event.touches[0];
        startDrag(gallery, touch.clientX, touch.clientY);
      }, { capture: true, passive: true });

      document.addEventListener('touchmove', (event) => {
        const gallery = event.target.closest?.('[data-lyma-gallery]');
        if (!gallery || event.touches.length !== 1) return;

        const touch = event.touches[0];
        moveDrag(gallery, touch.clientX, touch.clientY, event);
      }, { capture: true, passive: false });

      document.addEventListener('touchend', (event) => {
        const gallery = event.target.closest?.('[data-lyma-gallery]');
        if (!gallery) return;
        endDrag(gallery);
      }, true);

      document.addEventListener('touchcancel', (event) => {
        const gallery = event.target.closest?.('[data-lyma-gallery]');
        if (!gallery) return;
        endDrag(gallery);
      }, true);

      /* Desktop theme-editor / mouse fallback */
      let mouseGallery = null;

      document.addEventListener('mousedown', (event) => {
        if (event.button !== 0) return;
        const gallery = event.target.closest?.('[data-lyma-gallery]');
        if (!gallery) return;

        mouseGallery = gallery;
        startDrag(gallery, event.clientX, event.clientY);
      }, true);

      document.addEventListener('mousemove', (event) => {
        if (!mouseGallery) return;
        moveDrag(mouseGallery, event.clientX, event.clientY, event);
      }, { capture: true, passive: false });

      document.addEventListener('mouseup', () => {
        if (!mouseGallery) return;
        endDrag(mouseGallery);
        mouseGallery = null;
      }, true);

      /* Use the existing product form for direct adds; required choices belong on the product page. */
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest?.('[data-lyma-product-choice-url], [data-lyma-quick-add-form-target]');
        if (!trigger) return;

        event.preventDefault();
        event.stopPropagation();

        const card = trigger.closest('.card-wrapper');
        if (!card) return;
        if (trigger.dataset.lymaProductChoiceUrl) {
          window.location.assign(trigger.dataset.lymaProductChoiceUrl);
          return;
        }

        const formTarget = trigger.dataset.lymaQuickAddFormTarget;
        if (!formTarget) return;
        const submit = card.querySelector(formTarget);
        if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
        if (trigger.classList.contains('is-loading')) return;
        resetCollectionQuickAdd(trigger);
        trigger.classList.add('is-loading');
        trigger.setAttribute('aria-busy', 'true');
        window.__lymaPendingCollectionQuickAdd = trigger;
        submit.click();
      }, true);

      const resetCollectionQuickAdd = (trigger) => {
        if (!trigger) return;
        clearTimeout(trigger.lymaFeedbackTimer);
        trigger.classList.remove('is-loading', 'is-success');
        trigger.removeAttribute('aria-busy');
        trigger.removeAttribute('aria-disabled');
        if (window.__lymaPendingCollectionQuickAdd === trigger) {
          window.__lymaPendingCollectionQuickAdd = null;
        }
      };

      const markCollectionQuickAddSuccess = () => {
        const trigger = window.__lymaPendingCollectionQuickAdd;
        if (!trigger) return;
        trigger.classList.remove('is-loading');
        trigger.classList.add('is-success');
        trigger.setAttribute('aria-disabled', 'true');
        trigger.removeAttribute('aria-busy');
        trigger.lymaFeedbackTimer = setTimeout(() => resetCollectionQuickAdd(trigger), 800);
      };

      /* product-form.js publishes these existing events after Shopify confirms
         the add (or rejects it). No timeout is used to infer success. */
      const bindCollectionQuickAddEvents = () => {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event?.source === 'product-form') markCollectionQuickAddSuccess();
        });
        subscribe(PUB_SUB_EVENTS.cartError, () => {
          resetCollectionQuickAdd(window.__lymaPendingCollectionQuickAdd);
        });
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bindCollectionQuickAddEvents, { once: true });
      } else {
        bindCollectionQuickAddEvents();
      }

      /* Legacy direct-add handler retained for backwards compatibility, but
         no current collection trigger uses its data attribute. */
      /* LYMA quick add op de collectiepagina.
         Voegt direct toe en opent daarna de bestaande Dawn cart drawer. */
      document.addEventListener('click', async (event) => {
        const trigger = event.target.closest?.('[data-lyma-quick-add]');
        if (!trigger) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (trigger.classList.contains('is-loading')) return;

        const variantId = trigger.dataset.variantId;
        if (!variantId) return;

        trigger.classList.add('is-loading');
        trigger.setAttribute('aria-busy', 'true');

        try {
          const cartDrawer = document.querySelector('cart-drawer');
          const sections = ['cart-drawer', 'cart-icon-bubble'];

          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: Number(variantId),
                quantity: 1
              }],
              sections: sections.join(','),
              sections_url: window.location.pathname
            })
          });

          const data = await response.json();

          if (!response.ok || data.status) {
            throw new Error(
              data.description || data.message || 'Product kon niet worden toegevoegd.'
            );
          }

          trigger.classList.remove('is-loading');
          trigger.classList.add('is-added');
          trigger.removeAttribute('aria-busy');

          /* ======================================================
             LYMA quick-add fix
             Houd het bestaande <cart-drawer> element intact, zodat Dawn's
             JavaScript-methodes blijven werken. Vervang alleen de inhoud van
             #CartDrawer met de vers gerenderde Shopify-cart.
             ====================================================== */
          const parser = new DOMParser();
          const drawerHTML = data.sections?.['cart-drawer'];

          if (cartDrawer && drawerHTML) {
            const doc = parser.parseFromString(drawerHTML, 'text/html');
            const freshDrawer = doc.querySelector('cart-drawer');
            const freshInner = doc.querySelector('#CartDrawer');
            const currentInner = cartDrawer.querySelector('#CartDrawer');

            if (freshInner && currentInner) {
              currentInner.innerHTML = freshInner.innerHTML;

              if (freshDrawer?.classList.contains('is-empty')) {
                cartDrawer.classList.add('is-empty');
              } else {
                cartDrawer.classList.remove('is-empty');
              }

              /* Eventuele oude blocking styles van de overlay opruimen. */
              const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
              if (overlay) {
                overlay.style.removeProperty('display');
                overlay.style.removeProperty('opacity');
                overlay.style.removeProperty('visibility');
                overlay.style.removeProperty('pointer-events');
              }

              window.setTimeout(() => {
                if (typeof cartDrawer.open === 'function') {
                  cartDrawer.open();
                } else {
                  cartDrawer.classList.add('active');
                  cartDrawer.classList.add('animate');
                  document.body.classList.add('overflow-hidden');
                }
              }, 30);
            } else if (typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(data);
              window.setTimeout(() => {
                if (typeof cartDrawer.open === 'function') cartDrawer.open();
              }, 30);
            }
          } else if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data);
            window.setTimeout(() => {
              if (typeof cartDrawer.open === 'function') cartDrawer.open();
            }, 30);
          }

          /* Cart-icoon/badge apart verversen. */
          const bubbleHTML = data.sections?.['cart-icon-bubble'];
          if (bubbleHTML) {
            const bubbleDoc = parser.parseFromString(bubbleHTML, 'text/html');
            const newBubble = bubbleDoc.querySelector('#cart-icon-bubble');
            const oldBubble = document.querySelector('#cart-icon-bubble');
            if (newBubble && oldBubble) oldBubble.replaceWith(newBubble);
          }

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { cart: data }
            })
          );

          window.setTimeout(() => {
            trigger.classList.remove('is-added');
          }, 500);
        } catch (error) {
          trigger.classList.remove('is-loading');
          trigger.removeAttribute('aria-busy');
          console.error('Lyma quick add:', error);
          window.alert(
            error.message || 'Product kon niet worden toegevoegd aan de winkelmand.'
          );
        }
      }, true);

      /* Tap op de afbeelding opent het product, maar een swipe niet. */
      document.addEventListener('click', (event) => {
        const slide = event.target.closest?.('[data-lyma-slide]');
        if (!slide) return;

        const gallery = slide.closest('[data-lyma-gallery]');
        const st = getState(gallery);

        if (st.suppressClick) {
          event.preventDefault();
          event.stopImmediatePropagation();
          st.suppressClick = false;
          return;
        }

        const url = slide.dataset.productUrl;
        if (url) {
          event.preventDefault();
          window.location.href = url;
        }
      }, true);

      document.addEventListener('keydown', (event) => {
        const slide = event.target.closest?.('[data-lyma-slide]');
        if (!slide || (event.key !== 'Enter' && event.key !== ' ')) return;
        event.preventDefault();
        const url = slide.dataset.productUrl;
        if (url) window.location.href = url;
      });

      const init = () => {
        document.querySelectorAll('[data-lyma-gallery]').forEach((gallery) => {
          const st = getState(gallery);
          const max = Math.max(0, slideCount(gallery) - 1);
          st.index = Math.min(st.index, max);
          render(gallery, false, 0);
        });
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
      } else {
        init();
      }

      window.addEventListener('resize', init);

      /* Shopify collection filters can replace the product grid with AJAX.
         Re-render newly inserted cards without rebinding events. */
      const observer = new MutationObserver(() => {
        document.querySelectorAll('[data-lyma-gallery]').forEach((gallery) => {
          if (!states.has(gallery)) render(gallery, false, 0);
        });
      });

      if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
      }
    })();
